import React, { Suspense, lazy, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import * as Loading from "@repoflow/components/loading";

import { Filter, DEFAULT_RANGE, buildFilter, rangeLabel } from "components/statistics/filter";

// recharts and its d3 tree are ~100KB gzipped. Lazily loaded so /day — the
// section this app is actually worked in — never pays for them, the same way the other three dashboards do it.
// `Filter` above is imported eagerly because it must render before the chunk
// lands, and it is what the e2e waits on.
const OrganizationCharts = lazy(() => import("../charts"));

export const Sidebar = () => null;

export const Indice = () => null;

// Everything about this ORGANIZATION that is a number, on one screen: what it
// did over the selected window. This is auth's and datum's dashboard exactly —
// the same filter row over the same charts. bucketws' keeps one panel above its
// filter, and that is not a divergence: its panel is the organization's OWN size
// limit, one row scoped to the same thing the screen is scoped to. noshchat
// declares no limit against its statistics point, so there is no equivalent row
// to draw here.
//
// EVERYTHING HERE IS A WINDOW, and two of the three measures in it are deltas:
// +1 as an entry or key appears and -1 as it goes. So nothing on this screen
// is a holding — "how many entries does this organization have" is a sum over
// all of history, and datum clamps a capture window to 31 days. The third,
// sessions, only ever adds, so its total is complete.
export const Content = () => {
  const [applied, setApplied] = useState(() => ({
    filter: buildFilter({ range: DEFAULT_RANGE }),
    range: DEFAULT_RANGE,
  }));

  return (
    <Container>
      <div className="mt-4"></div>

      {/* One filter row above everything it scopes. Both aggregates below
          re-render against this slice and neither has a filter of its own.

          It produces a range and an event type, and no dimension at all: orgId
          is forced by the server and rejected if sent, and meal is grouped by
          rather than filtered on. */}
      <Row>
        <Col>
          <Filter onApply={setApplied} />
        </Col>
      </Row>

      <Row>
        <Col>
          <Suspense fallback={<Loading.Content />}>
            <OrganizationCharts
              filter={applied.filter}
              range={applied.range}
              rangeLabel={rangeLabel(applied.range)}
            />
          </Suspense>
        </Col>
      </Row>
    </Container>
  );
};
